import Typography from '@mui/material/Typography';
import { useUpdateUserSettings } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toggle } from 'shared/components/ui/toggle';
import { useUser } from 'shared/hooks/use-user';

import * as Styled from './filter-bar.style';

export const FilterBar: React.FC = () => {
  const { t } = useTranslation();
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  const updateUnplannedGoals = () =>
    updateUserSettings({
      goalsOverview: {
        roadmap: {
          hideUnplannedGoals:
            !user?.settings?.goalsOverview?.roadmap?.hideUnplannedGoals,
        },
      },
    });
  const updateCompletedGoals = () =>
    updateUserSettings({
      goalsOverview: {
        roadmap: {
          hideCompletedGoals:
            !user?.settings?.goalsOverview?.roadmap?.hideCompletedGoals,
        },
      },
    });
  const updateArchivedGoals = () =>
    updateUserSettings({
      goalsOverview: {
        roadmap: {
          hideArchivedGoals:
            !user?.settings?.goalsOverview?.roadmap?.hideArchivedGoals,
        },
      },
    });
  const updateEmptyLifeAreas = () =>
    updateUserSettings({
      goalsOverview: {
        roadmap: {
          showEmptyLifeAreas:
            !user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas,
        },
      },
    });

  return (
    <Styled.Container>
      <Styled.Filter>
        <Typography variant="buttonSmall" component="label" htmlFor="no-dates">
          {t('pages.goals.filters.no-dates.label')}
        </Typography>
        <Toggle
          value="no-dates"
          id="no-dates"
          onChange={updateUnplannedGoals}
          checked={!!user?.settings?.goalsOverview?.roadmap?.hideUnplannedGoals}
          isSmall
        />
      </Styled.Filter>

      <Styled.Filter>
        <Typography
          variant="buttonSmall"
          component="label"
          htmlFor="completed-goals"
        >
          {t('pages.goals.filters.completed-goals.label')}
        </Typography>
        <Toggle
          value="completed-goals"
          id="completed-goals"
          onChange={updateCompletedGoals}
          checked={!!user?.settings?.goalsOverview?.roadmap?.hideCompletedGoals}
          isSmall
        />
      </Styled.Filter>

      <Styled.Filter>
        <Typography
          variant="buttonSmall"
          component="label"
          htmlFor="archived-goals"
        >
          {t('pages.goals.filters.archived-goals.label')}
        </Typography>
        <Toggle
          value="archived-goals"
          id="archived-goals"
          onChange={updateArchivedGoals}
          checked={!!user?.settings?.goalsOverview?.roadmap?.hideArchivedGoals}
          isSmall
        />
      </Styled.Filter>

      <Styled.Filter>
        <Typography
          variant="buttonSmall"
          component="label"
          htmlFor="empty-life-areas"
        >
          {t('pages.goals.filters.empty-life-areas.label')}
        </Typography>
        <Toggle
          value="empty-life-areas"
          id="empty-life-areas"
          onChange={updateEmptyLifeAreas}
          checked={!user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas}
          isSmall
        />
      </Styled.Filter>
    </Styled.Container>
  );
};
